// src/app/utils/app-initializer.ts

import { AuthService } from "src/app/pages/auth";

export function appInitializer(authService: AuthService): () => Promise<void> {
  function hasPendingSsoCallback(): boolean {
  if (typeof window === "undefined") {
    return false;
  }

  const params = new URLSearchParams(window.location.search);
  const code = params.get("code")?.trim();

  return code != null && code !== "";
}
  return async () => {
    if (hasPendingSsoCallback()) {
      return;
    }

    return new Promise<void>((resolve) => {
      authService.restoreSession().subscribe({
        next: () => resolve(),
        error: () => resolve(),
        complete: () => resolve(),
      });
    });
  };
}


